import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Aalitech = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #0fa3e3, #22b0ea)' }}>
        <div className="hero-content">
          <h1>AALITECH</h1>
          <p>Empowering brands through digital marketing, web development, and innovative tech solutions — with more exciting services on the horizon</p>
        </div>
      </div>

      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            {/* Left column: About & Services */}
            <div className="left scroll-reveal">
              <h2>About AALITECH</h2>
              <p>AALITECH is a forward-thinking digital agency helping businesses grow through result-driven digital marketing, modern web development, and scalable tech solutions. We combine creativity with technology to build brands that stand out — and we're constantly evolving to bring new services to our clients.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Digital Marketing (SEO, Social Media, PPC)</div>
                <div className="service-item"><span>✔</span> Web Development & Design</div>
                <div className="service-item"><span>✔</span> Mobile App Development (iOS & Android)</div>
                <div className="service-item"><span>✔</span> UI/UX Design</div>
                <div className="service-item"><span>✔</span> More Services Coming Soon 🚀</div>
              </div>
            </div>

            {/* Right column: Info Card */}
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Technology</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <a href="https://aalitech.co/" className="btn-primary" target="_blank" rel="noopener noreferrer">
                  Visit Main Website
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Aalitech;